export const SUPPORT_EMAIL = "support@myfireplane.com";
